import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

const CUSTOMER_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.CUSTOMER,
  false // No tenant ID in the base URL
);

export const customerApi = {
  getCustomerList: () => apiClient.get(`${CUSTOMER_BASE}/list`),
  getCustomer: id => apiClient.get(`${CUSTOMER_BASE}/${id}`),
  createCustomer: combinedData =>
    apiClient.post(`${CUSTOMER_BASE}`, combinedData),
  updateCustomer: (id, combinedData) =>
    apiClient.put(`${CUSTOMER_BASE}/${id}`, combinedData),
  deleteCustomer: id => apiClient.delete(`${CUSTOMER_BASE}/${id}`)
};
export default customerApi;
